/**
 * A strategic objective used as a criterion (migration 1066) is keyed
 * `objective_` + the objective's id without dashes — the key the database gives it
 * (internal_objective_criterion_key). One rule, read by the web app
 * (src/lib/objectiveCriteria.ts) and the public API (routes/tracks.ts). The iPhone
 * mirrors it in apps/ios/Priorities/TrackDetailViews.swift (ObjectiveCriteria).
 */

export const OBJECTIVE_CRITERION_KEY_PREFIX = 'objective_';

/** The criterion key the database gives an objective. */
export function objectiveCriterionKey(objectiveId: string): string {
  return `${OBJECTIVE_CRITERION_KEY_PREFIX}${objectiveId.replace(/-/g, '').toLowerCase()}`;
}

/** True for a criterion key that stands for a strategic objective. */
export function isObjectiveCriterionKey(key: string | null | undefined): boolean {
  return typeof key === 'string' && key.startsWith(OBJECTIVE_CRITERION_KEY_PREFIX) &&
    key.length === OBJECTIVE_CRITERION_KEY_PREFIX.length + 32;
}
